import React from 'react';
import PropTypes from 'prop-types';

class Hexa extends React.PureComponent {
  render() {
    const { stroke, fill, width, height, strokeWidth, text, textColor, ...other } = this.props;
    return (
      <svg {...other} viewBox="0 0 100 100" width={width} height={height}>
        <polygon points="50,0 93,25 93,75 50,100 7,75 7,25" style={{ stroke, fill, strokeWidth }} />
        {text !== '' ? (
          <text fontFamily="Roboto" fontSize="40" x="50" y="63" textAnchor="middle" style={{ fill: textColor }}>
            {text}
          </text>
        ) : null}
      </svg>
    );
  }
}

Hexa.propTypes = {
  width: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  stroke: PropTypes.string,
  fill: PropTypes.string,
  text: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  strokeWidth: PropTypes.number,
  textColor: PropTypes.string,
};

Hexa.defaultProps = {
  width: 100,
  height: 120,
  stroke: '',
  fill: '',
  strokeWidth: 4,
  text: '',
  textColor: '#fff',
};

export default Hexa;
